import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import Header from './components/common/Header.jsx';
import Footer from './components/common/Footer.jsx';
import ProtectedRoute from './components/common/ProtectedRoute.jsx';
import ErrorBoundary from './components/common/ErrorBoundary.jsx';
import Homepage from './components/pages/Homepage.jsx';
import Login from './components/auth/Login.jsx';
import Register from './components/auth/Register.jsx';
import ForgotPassword from './components/auth/ForgotPassword.jsx';
import UpdatePassword from './components/auth/UpdatePassword.jsx';
import Dashboard from './components/dashboard/Dashboard.jsx';
import ProjectDetails from './components/dashboard/ProjectDetails.jsx';
import CreateProject from './components/projects/CreateProject.jsx';
import EditCollaborators from './components/projects/EditCollaborators.jsx';
import UpdateProjectPassword from './components/projects/UpdateProjectPassword.jsx';
import Profile from './components/profile/Profile.jsx';
import AboutUs from './components/pages/AboutUs.jsx';
import OurTeam from './components/pages/OurTeam.jsx';
import PrivacyPolicy from './components/pages/PrivacyPolicy.jsx';
import TermsOfService from './components/pages/TermsOfService.jsx';
import FAQ from './components/pages/FAQ.jsx';
import Feedback from './components/pages/Feedback.jsx';
import './styles/main.css';
import './styles/pages.css';

// Import debug helpers for development
import './utils/debugHelpers.js';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Homepage route */}
              <Route path="/" element={<Homepage />} />
              
              {/* Auth routes - these will show the full layout with Header/Footer */}
              <Route path="/login" element={
                <>
                  <Header />
                  <Login />
                  <Footer />
                </>
              } />
              <Route path="/register" element={
                <>
                  <Header />
                  <Register />
                  <Footer />
                </>
              } />
              <Route path="/forgot-password" element={
                <>
                  <Header />
                  <ForgotPassword />
                  <Footer />
                </>
              } />
              
              {/* Public informational pages */}
              <Route path="/about" element={
                <>
                  <Header />
                  <AboutUs />
                  <Footer />
                </>
              } />
              <Route path="/team" element={
                <>
                  <Header />
                  <OurTeam />
                  <Footer />
                </>
              } />
              <Route path="/privacy-policy" element={
                <>
                  <Header />
                  <PrivacyPolicy />
                  <Footer />
                </>
              } />
              <Route path="/terms-of-service" element={
                <>
                  <Header />
                  <TermsOfService />
                  <Footer />
                </>
              } />
              <Route path="/faq" element={
                <>
                  <Header />
                  <FAQ />
                  <Footer />
                </>
              } />
              <Route path="/feedback" element={
                <>
                  <Header />
                  <Feedback />
                  <Footer />
                </>
              } />
              
              {/* Protected routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <Dashboard />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/profile" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <Profile />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/project/:projectId" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <ProjectDetails />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/create-project" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <CreateProject />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/edit-collaborators/:projectId" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <EditCollaborators />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/update-project-password/:projectId" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <UpdateProjectPassword />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="/update-password" element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <UpdatePassword />
                    <Footer />
                  </>
                </ProtectedRoute>
              } />
              
              {/* Fallback route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;